namespace $.$$ {

	/** Numeric or textual count; role="status" for a static indicator. */
	export class $eve_badge extends $.$eve_badge {

		@$mol_mem
		value() {
			return ''
		}

	}

}
